/**
 * Load Optimizely event listeners
 */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", function () {

	if (pmwDataLayer?.pixels?.optimizely?.project_id && !pmwDataLayer?.pixels?.optimizely?.loaded) {
		if (pmw.consent.canPixelBeFired("statistics", "Optimizely")) pmw.loadOptimizelyPixel()
	}
})
